import React from 'react'

function Settingsvg({ fill}) {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34.56"
                height="35.489"
                viewBox="0 0 34.56 35.489"
                className="w-10 h-7"
                style={{ fill: fill }}
            >
                <defs>
                    <style></style>
                </defs>
                <g transform="translate(-6.705)">
                    <g transform="translate(6.705)">
                        <path
                            className="a"
                            d="M40.666,21.635,37.4,19.084a12.437,12.437,0,0,0,.077-1.34A12.843,12.843,0,0,0,37.4,16.4l3.265-2.552a1.6,1.6,0,0,0,.386-2.038L37.663,5.946A1.6,1.6,0,0,0,35.7,5.241L31.851,6.786a13.13,13.13,0,0,0-2.31-1.341l-.586-4.083A1.57,1.57,0,0,0,27.389,0h-6.8a1.568,1.568,0,0,0-1.566,1.347l-.587,4.1a13.611,13.611,0,0,0-2.307,1.343l-3.859-1.55a1.572,1.572,0,0,0-1.947.693l-3.4,5.878a1.586,1.586,0,0,0,.384,2.047L10.57,16.4a12.92,12.92,0,0,0-.077,1.34c0,.407.025.84.074,1.34L7.3,21.638a1.6,1.6,0,0,0-.385,2.038l3.392,5.869a1.6,1.6,0,0,0,1.962.705L16.121,28.7a13.328,13.328,0,0,0,2.311,1.341l.586,4.081a1.57,1.57,0,0,0,1.567,1.362h6.8a1.568,1.568,0,0,0,1.566-1.347l.587-4.1A13.611,13.611,0,0,0,31.847,28.7l3.859,1.55a1.577,1.577,0,0,0,1.947-.693l3.41-5.9A1.6,1.6,0,0,0,40.666,21.635Zm-.895,1.3-3.522,5.941-4.234-1.7a.742.742,0,0,0-.719.095,12.25,12.25,0,0,1-2.71,1.573.739.739,0,0,0-.452.58l-.747,4.586-6.9-.078-.646-4.506a.742.742,0,0,0-.452-.58,11.782,11.782,0,0,1-2.7-1.569.736.736,0,0,0-.451-.154.724.724,0,0,0-.276.053L11.6,28.82,8.208,22.951a.125.125,0,0,1,.01-.152l3.589-2.805a.741.741,0,0,0,.278-.674,12.475,12.475,0,0,1-.114-1.575,12.773,12.773,0,0,1,.114-1.575.739.739,0,0,0-.278-.674L8.2,12.554l3.522-5.941,4.234,1.7a.738.738,0,0,0,.72-.095,12.159,12.159,0,0,1,2.71-1.573.742.742,0,0,0,.451-.58l.748-4.587,6.9.08.645,4.507a.742.742,0,0,0,.452.58,11.738,11.738,0,0,1,2.7,1.569.734.734,0,0,0,.726.1l4.355-1.643,3.392,5.869a.123.123,0,0,1-.01.151L36.165,15.5a.739.739,0,0,0-.278.674A12.576,12.576,0,0,1,36,17.745a12.555,12.555,0,0,1-.114,1.575.741.741,0,0,0,.278.674l3.584,2.8A.117.117,0,0,1,39.771,22.936Z"
                            transform="translate(-6.705)"
                        />
                        <path
                            className="a"
                            d="M156.746,149.333a7.394,7.394,0,1,0,7.394,7.394A7.4,7.4,0,0,0,156.746,149.333Zm0,13.308a5.915,5.915,0,1,1,5.915-5.915A5.921,5.921,0,0,1,156.746,162.641Z"
                            transform="translate(-139.464 -138.982)"
                        />
                    </g>
                </g>
            </svg>
        </>
    )
}

export default Settingsvg
